

// Form Label Animation
// -----------------------------------------------------------------------------
(function init() {
    var allInputs = jQuery('input, textarea, select');
    allInputs.each(function () {

        if (jQuery(this).val() != "" && jQuery(this).val() != "undefined" && typeof jQuery(this).val() !== "undefined") {
            jQuery(this).addClass('has-input');
            jQuery(this).closest('.form-row').addClass('has-input');
        }

        jQuery(this).focus(function () {
            // console.log('focus input');
            jQuery(this).addClass('focus');
            jQuery(this).closest('.form-row').addClass('focus');
        });

        jQuery(this).blur(function () {
            jQuery(this).removeClass('focus');
            jQuery(this).closest('.form-row').removeClass('focus');

            if (jQuery(this).val() !== '') {
                jQuery(this).addClass('has-input');
                jQuery(this).closest('.form-row').addClass('has-input');
            } else {
                jQuery(this).removeClass('has-input');
                jQuery(this).closest('.form-row').removeClass('has-input');
            }
        });

    });

    /* let inputs = document.querySelectorAll('input, textarea, select');

     // Loop and add listeners
     for(let i = 0; i < inputs.length; i++) {
         inputs[i].addEventListener('focus', function() {
             // console.log('focus input');
             inputs[i].classList.add('focus');
             inputs[i].closest('.form-row').classList.add('focus');
         });

         inputs[i].addEventListener('blur', function() {
             inputs[i].classList.remove('focus');
             inputs[i].closest('.form-row').classList.remove('focus');

             if(inputs[i].value !== '') {
                 inputs[i].classList.add('has-input');
                 inputs[i].closest('.form-row').classList.add('has-input');
             } else {
                 inputs[i].classList.remove('has-input');
                 inputs[i].closest('.form-row').classList.remove('has-input');
             }
         });
     }*/
})();

jQuery(function () {
    var inputItem = jQuery('input:not([type="checkbox"])');
    inputItem.each(function () {
        // console.log(inputItem);
        if (jQuery(this).length && jQuery(this).val().length) {
            // console.log('inputItem focus');
            jQuery(this).parent().addClass('focus');
        }
    });
});

(function init() {
    let textarea = document.querySelectorAll('textarea');

    // Loop and add listeners
    for(let i = 0; i < textarea.length; i++) {
        textarea[i].addEventListener('focus', function() {
            textarea[i].classList.add('focus');
            textarea[i].parentNode.classList.add('focus');
        });

        textarea[i].addEventListener('blur', function() {
            textarea[i].classList.remove('focus');
            textarea[i].parentNode.classList.remove('focus');

            if(textarea[i].value !== '') {
                textarea[i].classList.add('has-input');
                textarea[i].parentNode.classList.add('has-input');
            } else {
                textarea[i].classList.remove('has-input');
                textarea[i].parentNode.classList.remove('has-input');
            }
        });
    }
})();


// Product Filter functions
// -----------------------------------------------------------------------------
jQuery(".filter-reset").on("click", function () {
    jQuery('.custom-control-input').prop('checked', false).change();
});
jQuery("#submit_productfilter").on("click", function () {
    // console.log('submit_productfilter');
    jQuery("#productFilter .icon-close").trigger('click');
    jQuery('html, body').animate({scrollTop: jQuery('#p_cards').offset().top + (-64)}, 'slow');
});

/**Category Page Filter*/
jQuery(".custom-control-input").on("change", function () {
    handleProductFilter(jQuery(this));
});

function handleProductFilter(element, _form=null){
    let form = _form ? _form : element.closest("form");
    // Set action from form or default to "filter_product"
    let action = form.data("action") ? form.data("action") : "filter_product";
    // Set target from form or default to "filter_product"
    let target = form.data("target") ? jQuery(form.data("target")) : jQuery('#p_cards');
    let form_data = form.serializeArray();
    let filter = form.serialize();

    jQuery.ajax({
        type: 'POST',
        url: ajaxdata.ajaxurl,
        data: {
            action: action,
            fdata: form_data,
            filter: filter,
            cat_id: jQuery('#category_slug').text(),
        },
        success: function(data, textStatus, XMLHttpRequest) {
            target.html(data);
            if (filter) {
                window.history.replaceState({}, "", decodeURIComponent(location.pathname + '?' + filter))
            }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(errorThrown);
        }
    });
}

// Fill products panel on page load (Presse: Produktinformationen)
if (jQuery("#formProductInformationFilter").length) {
    handleProductFilter(null, jQuery("#formProductInformationFilter"));
}


jQuery(".like-question").each(function () {
    var q_id = jQuery(this).data('questionid');
    if (localStorage.getItem(q_id) == "1") {
        jQuery('.like-question[data-questionid="' + q_id + '"]').find('.icon-like').addClass('liked');
    }

});

jQuery(".like-question").on("click", function () {
    jQuery.ajax({
        type: 'POST',
        url: ajaxdata.ajaxurl,
        data: {
            action: 'faq_likes',
            question_id: jQuery(this).data('questionid'),
            liked: localStorage.getItem(jQuery(this).data('questionid')),
        },
        success: function (data, textStatus, XMLHttpRequest) {
            var mydata = JSON.parse(data);
            var likeid = '#likes_' + mydata['q_id'];
            jQuery(likeid).html(mydata['count']);
            if (localStorage.getItem(mydata['q_id']) == "1") {
                jQuery('.like-question[data-questionid="' + mydata['q_id'] + '"]').find('.icon-like').removeClass('liked');
                localStorage.removeItem(mydata['q_id']);
            } else {
                localStorage.setItem(mydata['q_id'], '1');
                jQuery('.like-question[data-questionid="' + mydata['q_id'] + '"]').find('.icon-like').addClass('liked');
            }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(errorThrown);
        }
    });
});
/*
jQuery('#openNewsletterModal').click(function(){
    var source = jQuery('#newsletterEmail').val();
    jQuery('#text5763070').val(source);
});
*/
jQuery('#newsletter_popup').on("submit", function (e) {
    e.preventDefault();
    var source = jQuery('#newsletterEmail').val();
    jQuery('#text6332984').val(source);
    jQuery('#exampleModal').modal('show');
});
